module.exports = __webpack_public_path__ + "img/SI-what-is@2x.2595414.png";